import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { SERVICES } from "../../lib/site";

export default function ServicesPreview() {
  return (
    <section data-testid="services-preview" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal className="mb-12 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <p className="text-xs uppercase tracking-[0.25em] text-gold">What we do</p>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-forest md:text-5xl">
              Complete solar solutions, end to end.
            </h2>
          </div>
          <Link to="/services" className="shrink-0 rounded-full border border-forest px-6 py-3 text-sm font-semibold text-forest transition-colors hover:bg-forest hover:text-cream">
            All services
          </Link>
        </Reveal>
        <div className="grid gap-5 md:grid-cols-3">
          {SERVICES.slice(0, 6).map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.06}>
              <Link to="/services" data-testid={`service-preview-${s.slug}`}
                className="group flex h-full flex-col rounded-3xl border border-line bg-white/50 p-7 transition-colors hover:border-gold/60">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-forest text-cream transition-colors group-hover:bg-gold group-hover:text-obsidian">
                  <s.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-5 font-heading text-xl font-bold text-forest">{s.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-moss">{s.short}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-forest">
                  Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
